"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MonthSelector = void 0;
const react_1 = __importStar(require("react"));
const common_1 = require("../common");
const DatetimeInputContext_1 = require("../controls/DatetimeInput/context/DatetimeInputContext");
const getDateWithOffset_1 = require("../controls/DatetimeInput/helpers/getDateWithOffset");
const helpers_1 = require("../helpers");
const icons_1 = require("../icons");
const MonthButton_1 = require("./components/MonthButton/MonthButton");
const YearButton_1 = require("./components/YearButton/YearButton");
const MonthSelector_styles_1 = require("./MonthSelector.styles");
const constants_1 = require("./helpers/constants");
exports.MonthSelector = (0, helpers_1.createUIElement)('MonthSelector', (_a, ref) => {
    var { className, shownYear, onSelect, selectedYear, selectedMonth, isYearDisabled, isMonthDisabled, texts, onClick, onMouseDown, onMouseUp, onMouseEnter, onMouseLeave, onKeyDown, onKeyUp, onKeyPress, style, ['data-selector-id']: initialDataSelectorId } = _a, rest = __rest(_a, ["className", "shownYear", "onSelect", "selectedYear", "selectedMonth", "isYearDisabled", "isMonthDisabled", "texts", "onClick", "onMouseDown", "onMouseUp", "onMouseEnter", "onMouseLeave", "onKeyDown", "onKeyUp", "onKeyPress", "style", 'data-selector-id']);
    const uiTexts = (0, react_1.useMemo)(() => (Object.assign(Object.assign({}, constants_1.DEFAULT_TEXTS), texts)), [texts]);
    const context = (0, react_1.useContext)(DatetimeInputContext_1.DatetimeInputContext);
    const now = (context === null || context === void 0 ? void 0 : context.getNowTime)
        ? context === null || context === void 0 ? void 0 : context.getNowTime()
        : (0, getDateWithOffset_1.getDateWithOffset)(new Date(), context.serverUtcOffset);
    const currentYear = (0, react_1.useMemo)(() => now.getFullYear(), [now]);
    const [startYear, setStartYear] = (0, react_1.useState)((shownYear || currentYear) - 4);
    (0, react_1.useEffect)(() => {
        setStartYear((shownYear || currentYear) - 4);
    }, [currentYear, shownYear]);
    const isPrevButtonDisabled = (0, react_1.useMemo)(() => {
        if (isYearDisabled) {
            return isYearDisabled(startYear) && isYearDisabled(startYear - 1);
        }
        return false;
    }, [isYearDisabled, startYear]);
    const isNextButtonDisabled = (0, react_1.useMemo)(() => {
        if (isYearDisabled) {
            return isYearDisabled(startYear + 9) && isYearDisabled(startYear + 10);
        }
        return false;
    }, [isYearDisabled, startYear]);
    return (react_1.default.createElement(MonthSelector_styles_1.StyledMonthSelector, Object.assign({}, rest, { ref: ref, style: style, "data-selector-id": initialDataSelectorId, onClick: onClick, onMouseDown: onMouseDown, onMouseUp: onMouseUp, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onKeyPress: onKeyPress, className: (0, helpers_1.cn)('vm-MonthSelector', className) }),
        react_1.default.createElement(MonthSelector_styles_1.StyledMonthSelectorBody, null,
            react_1.default.createElement(MonthSelector_styles_1.StyledMonthSelectorSection, null,
                react_1.default.createElement(MonthSelector_styles_1.StyledMonthSelectorColumn, null, [0, 1, 2, 3, 4, 5].map((value) => (react_1.default.createElement(MonthButton_1.MonthButton, { key: value, value: value, selectedValue: selectedMonth, disabled: isMonthDisabled && selectedYear
                        ? isMonthDisabled({ year: selectedYear, month: value })
                        : false, onSelect: (newValue) => {
                        if (onSelect) {
                            onSelect({ year: selectedYear, month: newValue });
                        }
                    }, texts: uiTexts, "data-selector-id": `${constants_1.dataSelectorId.monthControlPartId}-${value}` })))),
                react_1.default.createElement(MonthSelector_styles_1.StyledMonthSelectorColumn, null, [6, 7, 8, 9, 10, 11].map((value) => (react_1.default.createElement(MonthButton_1.MonthButton, { key: value, value: value, selectedValue: selectedMonth, disabled: isMonthDisabled && selectedYear
                        ? isMonthDisabled({ year: selectedYear, month: value })
                        : false, onSelect: (newValue) => {
                        if (onSelect) {
                            onSelect({ year: selectedYear, month: newValue });
                        }
                    }, texts: uiTexts }))))),
            react_1.default.createElement(MonthSelector_styles_1.StyledMonthSelectorSeparator, null),
            react_1.default.createElement(MonthSelector_styles_1.StyledMonthSelectorSection, null,
                react_1.default.createElement(MonthSelector_styles_1.StyledMonthSelectorColumn, null,
                    react_1.default.createElement(MonthSelector_styles_1.StyledMonthSelectorArrowContainer, null,
                        react_1.default.createElement(common_1.PaginationButton, { onClick: () => setStartYear((currentValue) => currentValue - 5), disabled: isPrevButtonDisabled, "data-selector-id": constants_1.dataSelectorId.prevListYearsControl },
                            react_1.default.createElement(icons_1.PreviousIcon, null))),
                    [0, 1, 2, 3, 4].map((value) => (react_1.default.createElement(YearButton_1.YearButton, { key: value, value: startYear + value, disabled: isYearDisabled ? isYearDisabled(startYear + value) : false, selectedValue: selectedYear, onSelect: (newValue) => {
                            if (onSelect) {
                                onSelect({ year: newValue, month: selectedMonth });
                            }
                        } })))),
                react_1.default.createElement(MonthSelector_styles_1.StyledMonthSelectorColumn, null,
                    react_1.default.createElement(MonthSelector_styles_1.StyledMonthSelectorArrowContainer, null,
                        react_1.default.createElement(common_1.PaginationButton, { onClick: () => setStartYear((currentValue) => currentValue + 5), disabled: isNextButtonDisabled, "data-selector-id": constants_1.dataSelectorId.nextListYearsControl },
                            react_1.default.createElement(icons_1.NextIcon, null))),
                    [5, 6, 7, 8, 9].map((value) => (react_1.default.createElement(YearButton_1.YearButton, { key: value, value: startYear + value, selectedValue: selectedYear, disabled: isYearDisabled ? isYearDisabled(startYear + value) : false, onSelect: (newValue) => {
                            if (onSelect) {
                                onSelect({ year: newValue, month: selectedMonth });
                            }
                        }, "data-selector-id": `${constants_1.dataSelectorId.yearControlPartId}-${value}` }))))))));
});
//# sourceMappingURL=MonthSelector.js.map